<script>
    export let tgVisible = true;
    export let teamColour = '';
    import { texts } from './texts.js';
    export let lang;
</script>

<div class="pop-ups">
    {#if teamColour === 'pomaranczowi'}
        <div class="pop-up " id="cel-pomaranczowy">
            <div class="pop-up-content1 cel-pomaranczowy">
                <div class="tresc1">
                    <div class="rules1">
                        {@html texts[lang].team_goal_orange}
                        <i
                            class="fas fa-times pop-up-close"
                            on:click={() => {
                                tgVisible = false;
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    {/if}
    {#if teamColour === 'zieloni'}
        <div class="pop-up" id="cel-zielony">
            <div class="pop-up-content1 cel-zielony">
                <div class="tresc1 ">
                    <div class="rules1">
                        {@html texts[lang].team_goal_green}
                        <i
                            class="fas fa-times pop-up-close"
                            on:click={() => {
                                tgVisible = false;
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    {/if}
    {#if teamColour === 'fioletowi'}
        <div class="pop-up " id="cel-fioletowy">
            <div class="pop-up-content1 cel-fioletowy">
                <div class="tresc1 ">
                    <div class="rules1">
                        {@html texts[lang].team_goal_purple}
                        <i
                            class="fas fa-times pop-up-close"
                            on:click={() => {
                                tgVisible = false;
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    {/if}
    {#if teamColour === 'niebiescy'}
        <div class="pop-up" id="cel-niebieski">
            <div class="pop-up-content1  cel-niebieski">
                <div class="tresc1">
                    <div class="rules1">
                        {@html texts[lang].team_goal_blue}
                        <i
                            class="fas fa-times pop-up-close"
                            on:click={() => {
                                tgVisible = false;
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    {/if}
</div>
